// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module--container--3rofJ"};